export default `
mutation AdminCreateProperty(
  $geofence: Int!,
  $place: PlaceInput!, 
  $adminNote: String, 
  $serviceProviderNote: String, 
  $serviceProviderId: String!
  $displayName: String!, 
  $patrolWindows: [PatrolWindowInput]!
  $variant: PropertyVariants!
) {
  adminCreateProperty(
    geofence: $geofence
    place: $place,
    serviceProviderId: $serviceProviderId,
    adminNote: $adminNote,
    serviceProviderNote: $serviceProviderNote,
    displayName: $displayName,
    patrolWindows: $patrolWindows,
    variant: $variant
  ) {
    variant
    patrolWindows {
      minsToStart
      minsToEnd
      darsRequired
    }
    geofence
    place {
      coordinates {
        lat
        lng
      }
      formattedAddress
      addressComponents {
        city
        state
        county
        country
        zipCode
        subpremise
        streetName
        neighborhood
        streetNumber
        zipCodeSuffix
      }
      timezone
    }
    isDeleted
    adminNote
    createdAt
    updatedAt
    propertyId
    instanceId
    instancedAt
    displayName
    cardinal {
      time {
        start
        end
      }
      indefiniteStart
      note
      indefinite
    }
    serviceProviderId
    serviceProviderNote
  }
}
`;